module.exports = __webpack_public_path__ + "static/HKGrotesk-LightItalic-fd5bdd7b8e067de9d3c793c98f7aabaf.ttf";